import { render } from "./Expedicao.vue?vue&type=template&id=18b1df0e&scoped=true"
import script from "./Expedicao.vue?vue&type=script&lang=js"
export * from "./Expedicao.vue?vue&type=script&lang=js"

import "./Expedicao.vue?vue&type=style&index=0&id=18b1df0e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b1df0e"]])

export default __exports__